(() => {
  const drawer = document.querySelector('cart-drawer');
  const isCartPage = document.body.classList.contains('am-cart-page');
  const syncCartFocus = () => document.body.classList.toggle('am-cart-focused', isCartPage || Boolean(drawer?.classList.contains('active')));
  syncCartFocus();
  if (drawer) new MutationObserver(syncCartFocus).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  let refreshController;
  async function refreshComplements() {
    const section = document.querySelector('[data-am-complements-section]');
    if (!section) return;
    refreshController?.abort();
    refreshController = new AbortController();
    section.querySelector('animall-cart-complements')?.setAttribute('hidden', '');
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', section.dataset.amComplementsSection);
      const response = await fetch(url, { signal: refreshController.signal });
      if (!response.ok) throw new Error('section');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updated = html.querySelector('[data-am-complements-section]');
      if (!updated) throw new Error('section');
      section.innerHTML = updated.innerHTML;
    } catch (error) {
      if (error.name !== 'AbortError') section.replaceChildren();
    }
  }
  document.addEventListener('animall:cart-updated', refreshComplements);
  document.addEventListener('click', (event) => {
    if (document.body.classList.contains('am-complement-pending') && event.target.closest('cart-remove-button')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  if (customElements.get('animall-cart-complements')) return;
  customElements.define('animall-cart-complements', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('submit', this.addComplement.bind(this));
    }
    async addComplement(event) {
      const form = event.target.closest('.am-complement-form');
      if (!form) return;
      event.preventDefault();
      if (this.busy || document.querySelector('.cart__items--disabled') || document.body.classList.contains('am-complement-pending')) return;
      this.busy = true;
      document.body.classList.add('am-complement-pending');
      const lockedControls = Array.from(document.querySelectorAll('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"], cart-items quantity-input button, cart-drawer-items quantity-input button, #checkout, #CartDrawer-Checkout')).map((element) => ({ element, disabled: element.disabled }));
      lockedControls.forEach(({ element }) => { element.disabled = true; });
      const button = form.querySelector('button');
      const previousLabel = button.textContent;
      this.querySelectorAll('button').forEach((item) => { item.disabled = true; });
      button.textContent = this.dataset.adding;
      this.setAttribute('aria-busy', 'true');
      const errorNode = this.querySelector('.am-complements-error');
      errorNode.hidden = true;
      const addedMessage = this.dataset.added;
      const cart = isCartPage ? document.querySelector('cart-items') : drawer;
      try {
        if (!cart?.getSectionsToRender) throw new Error('cart');
        const sections = cart.getSectionsToRender().filter((section) => !isCartPage || document.getElementById(section.id));
        const data = new FormData(form);
        data.set('sections', sections.map((section) => section.section || section.id).join(','));
        data.set('sections_url', window.location.pathname);
        const endpoint = new URL(form.action);
        endpoint.pathname += '.js';
        const response = await fetch(endpoint, { method: 'POST', body: data, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } });
        const state = await response.json();
        if (!response.ok || state.status || !state.sections) throw new Error('add');
        sections.forEach((section) => {
          const html = state.sections[section.section || section.id];
          const source = html && new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
          if (!source) throw new Error('render');
        });
        if (isCartPage) {
          const replacements = sections.map((section) => {
            const target = document.getElementById(section.id);
            const html = state.sections[section.section || section.id];
            const source = html && new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
            if (!target || !source) throw new Error('render');
            return { target: target.querySelector(section.selector) || target, html: source.innerHTML };
          });
          replacements.forEach(({ target, html }) => { target.innerHTML = html; });
          const itemsSection = sections.find((section) => section.id === 'main-cart-items');
          const itemsHtml = new DOMParser().parseFromString(state.sections[itemsSection.section], 'text/html');
          const deliveryBar = document.getElementById('cart-page-free-delivery');
          const deliverySource = itemsHtml.getElementById('cart-page-free-delivery');
          if (deliveryBar && deliverySource) deliveryBar.innerHTML = deliverySource.innerHTML;
          void refreshComplements();
          document.getElementById('checkout')?.focus();
        } else {
          drawer.renderContents(state);
          requestAnimationFrame(() => document.getElementById('CartDrawer-Checkout')?.focus());
        }
        document.getElementById('AnimallCartFeedback').textContent = addedMessage;
      } catch (error) {
        errorNode.textContent = this.dataset.error;
        errorNode.hidden = false;
        this.querySelector('.am-complements-refresh').hidden = false;
        button.textContent = previousLabel;
        this.querySelector('.am-complements-refresh').focus();
      } finally {
        document.body.classList.remove('am-complement-pending');
        lockedControls.forEach(({ element, disabled }) => { if (element.isConnected) element.disabled = disabled; });
        this.removeAttribute('aria-busy');
      }
    }
  });
})();
